/* eslint-disable import/no-anonymous-default-export */
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import TimeToLeaveOutlinedIcon from '@mui/icons-material/TimeToLeaveOutlined';
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";

export default [
  {
    name: "پروفایل",
    path: `/profile`,
    icon: SettingsOutlinedIcon,
  },
  // {
  //   name: "تاریخچه لحظه اخری",
  //   path: `/no-path-2`,
  //   icon: CheckIcon,
  // },
  // {
  //   name: "تاریخچه سفارش ها",
  //   path: `/tickets`,
  //   icon: LocalActivityIcon,
  // },
   {
    name: "سفر جدید",
    path: `/hiring`,
    icon: TimeToLeaveOutlinedIcon,
  },
  {
    name: "تاریخچه دربستی",
    path: `/hiring-list`,
    icon: FormatListBulletedIcon,
  },
  // {
  //   name: "برنامه هفتگی",
  //   path: `/weekly-plan`,
  //   icon: DateRangeIcon,
  // },
  // {
  //   name: "همپیمایی",
  //   path: `/ridesharing`,
  //   icon: GroupsOutlinedIcon,
  // },
  // {
  //   name: "مسیرها",
  //   path: `/paths`,
  //   icon: HomeOutlinedIcon,
  // },
  {
    name: "کیف پول",
    path: `/wallets`,
    icon: AccountBalanceWalletOutlinedIcon,
  },
  // {
  //   name: "پیشنهاد مسیر",
  //   path: `/survey`,
  //   icon: AddIcon,
  // },
  // {
  //   name: "تاکسی خطی",
  //   path: `/taxi`,
  //   icon: LocalTaxiOutlinedIcon,
  // },
  { type: "line" },
  {
    name: "راهنمای استفاده",
    path: `/howitworks`,
    icon: QuestionMarkIcon,
    websiteAddress: true,
  },
  {
    name: "سوالات متداول",
    path: `/faq`,
    icon: InfoOutlinedIcon,
    websiteAddress: true,
  },
  {
    name: "پشتیبانی",
    path: `/support`,
    icon: CallOutlinedIcon,
    websiteAddress: true,
  },{
    name: "خروج",
    path: `/logout`,
    icon: PowerSettingsNewOutlinedIcon,
  },
];
